{
  "titles": {
    "menu": "Partners",
    "table": "Partners",
    "create": "Partner aanmaken",
    "update": "Partner wijzigen",
    "advisors": "Adviseurs",
    "funders": "Spaarders",
    "details": "Algemeen",
    "reports": "Inzichten",
    "financeReceivers": "Klanten",
    "sendAgreements": "Partnercontract versturen",
    "invoiceInformation": "Facturatie gegevens",
    "settings": "Instellingen",
    "companyInformation": "Bedrijfsinformatie",
    "signingAuthorities": "Ondertekenaars",
    "signingAuthorityNumber": "Ondertekenaar {number}",
    "partner": "Partner",
    "partnerDetails": "Partner informatie",
    "files": "Documenten"
  },
  "fields": {
    "labels": {
      "name": "Bedrijfsnaam",
      "companySearch": "Zoek bedrijf",
      "partnerTypes": "Soort partner",
      "businessType": "Soort bedrijf",
      "legalStructure": "Rechtsvorm",
      "registrationNumber": "KvK- of registratienummer",
      "registeredOffice": "Statutaire zetel",
      "signingAuthorities": "Ondertekenaars",
      "address": "Adres",
      "partnerSince": "Partner sinds",
      "phone": "Algemeen telefoonnummer",
      "iban": "IBAN",
      "bic": "BIC",
      "beneficiaryName": "Naam begunstigde",
      "sendFunderAgreement": "Stuur samenwerkingsovereenkomst",
      "agreements": "Overeenkomsten",
      "feeGroup": "Partner fee",
      "signingAuthority": {
        "firstNames": "Voornamen",
        "initials": "Initialen",
        "lastName": "Achternaam",
        "role": "Functie",
        "dateOfBirth": "Geboortedatum",
        "email": "E-mail",
        "identityValidationMethod": "Identificatie methode digitaal verzenden",
        "isIdentityValidated": "Identiteit is handmatig gecontroleerd"
      },
      "invoiceInformationTitle": "Facturatie gegevens",
      "invoiceInformation": {
        "firstNames": "Voornamen",
        "initials": "Initialen",
        "lastName": "Achternaam",
        "email": "E-mail"
      },
      "isAllowedToSetFunderToManageContracts": "Partner bepaalt of spaarders contracten mogen aandragen",
      "isBlocked": "Geblokkeerd",
      "status": "Actief"
    },
    "hints": {
    },
    "validationErrors": {
      "companySearch": {
        "required": "Een bedrijf selecteren is verplicht",
        "unique": "Dit bedrijf is al een partner"
      }
    }
  },
  "funderAgreementStatus": {
    "Open": "Samenwerkingsovereenkomst niet verstuurd",
    "Sent": "Samenwerkingsovereenkomst verstuurd op {at}",
    "Signed": "Samenwerkingsovereenkomst getekend"
  },
  "headers": {
    "labels": {
      "isBlocked": "Status",
      "numberOfAdvisors": "Aantal adviseurs"
    }
  },
  "messages": {
    "createSuccess": "Partner aangemaakt",
    "updateSuccess": "Partner is opgeslagen"
  },
  "actions": {
    "create": "Partner aanmaken",
    "createAdvisor": "Adviseur aanmaken",
    "createFunder": "Spaarder aanmaken",
    "update": "Partner aanpassen",
    "search": "Zoek een partner",
    "addSigningAuthority": "Ondertekenaar toevoegen"
  },
  "partnerIsBlockedStatus": {
    "partnerIsBlockedTrue": "Geblokkeerde partner",
    "partnerIsBlockedFalse": "Actieve partner"
  }
}
